import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const IPay88Result = () => {
  return <CommonResult />;
};

export default IPay88Result;
